import { render } from "./ChangeBalance.vue?vue&type=template&id=627068d2"
import script from "./ChangeBalance.vue?vue&type=script&lang=js"
export * from "./ChangeBalance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__